import React, { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import { FaBars } from 'react-icons/fa'
import { apiURL, sitePath } from 'config/globals'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import Breadcrumbs from 'components/Breadcrumbs'
import Footer from 'components/Footer'
import { checkAuth } from 'utils/Auth'

const CraftRecordList = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [records, setRecords] = useState([])
    const navigate = useNavigate()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            getRecords()
        }
        start()
    }, [])

    const getRecords = async () => {
        const response = await axios.get(`${apiURL}/get-records`)
        setRecords(response.data.rows || [])
    }

    const viewRecord = (id) => {
        const record = records.find(x => x.id === id)
        navigate(`/buildings/${record.buildingId}/records/${record.id}`)
    }

    return (
        <>
            <Topbar currentUser={currentUser} />
            <Sidebar selectedItem="records" currentUser={currentUser} />
            <main>
                <Breadcrumbs items={[['Craft Archive']]} />
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <div className="float-start">
                        <h1>Craft Archive</h1>
                    </div>
                </header>
                <div>
                    Under construction...
                </div>
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default CraftRecordList